export type KeyData = {
  [keyName: string]: {
    keyType: "default" | "shift" | "option";
    position: number[];
    hand: "left" | "right";
    finger: "thumb" | "first" | "second" | "third" | "fourth";
    size?:
      | "S"
      | "M"
      | "L"
      | "XL"
      | "XXL"
      | "XXXL"
      | "us-space"
      | "jis-space"
      | "mac-jis-space"
      | "mac-us-space"
      | "hexaEnter";
    pushCount?: number;
    missCount?: number;
    timeSecCount?: number;
    speed?: number;
    accuracy?: number;
  };
};

export type KeyboardData = {
  [keyboardType in "jis" | "us" | "mac-jis" | "mac-us"]: KeyData;
};

export const keyboardData: KeyboardData = {
  jis: {
    半角全角: {
      keyType: "default",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
    },
    "1": {
      keyType: "default",
      position: [0, 1],
      hand: "left",
      finger: "fourth",
    },
    "!": {
      keyType: "shift",
      position: [0, 1],
      hand: "left",
      finger: "fourth",
    },
    "2": {
      keyType: "default",
      position: [0, 2],
      hand: "left",
      finger: "third",
    },
    '"': {
      keyType: "shift",
      position: [0, 2],
      hand: "left",
      finger: "third",
    },
    "3": {
      keyType: "default",
      position: [0, 3],
      hand: "left",
      finger: "second",
    },
    "#": {
      keyType: "shift",
      position: [0, 3],
      hand: "left",
      finger: "second",
    },
    "4": {
      keyType: "default",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    $: {
      keyType: "shift",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    "5": {
      keyType: "default",
      position: [0, 5],
      hand: "left",
      finger: "first",
    },
    "%": {
      keyType: "shift",
      position: [0, 5],
      hand: "left",
      finger: "first",
    },
    "6": {
      keyType: "default",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "&": {
      keyType: "shift",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "7": {
      keyType: "default",
      position: [0, 7],
      hand: "right",
      finger: "first",
    },
    "'": {
      keyType: "shift",
      position: [0, 7],
      hand: "right",
      finger: "first",
    },
    "8": {
      keyType: "default",
      position: [0, 8],
      hand: "right",
      finger: "second",
    },
    "(": {
      keyType: "shift",
      position: [0, 8],
      hand: "right",
      finger: "second",
    },
    "9": {
      keyType: "default",
      position: [0, 9],
      hand: "right",
      finger: "third",
    },
    ")": {
      keyType: "shift",
      position: [0, 9],
      hand: "right",
      finger: "third",
    },
    "0": {
      keyType: "default",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    "~": {
      keyType: "shift",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    "-": {
      keyType: "default",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    "=": {
      keyType: "shift",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    "^": {
      keyType: "default",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    "¯": {
      keyType: "shift",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    "¥": {
      keyType: "default",
      position: [0, 13],
      hand: "right",
      finger: "fourth",
    },
    "|": {
      keyType: "shift",
      position: [0, 13],
      hand: "right",
      finger: "fourth",
    },
    Backspace: {
      keyType: "default",
      position: [0, 14],
      hand: "right",
      finger: "fourth",
    },
    Tab: {
      keyType: "default",
      position: [1, 0],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    q: {
      keyType: "default",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    Q: {
      keyType: "shift",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    w: {
      keyType: "default",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    W: {
      keyType: "shift",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    e: {
      keyType: "default",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    E: {
      keyType: "shift",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    r: {
      keyType: "default",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    R: {
      keyType: "shift",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    t: {
      keyType: "default",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    T: {
      keyType: "shift",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    y: {
      keyType: "default",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    Y: {
      keyType: "shift",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    u: {
      keyType: "default",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    U: {
      keyType: "shift",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    i: {
      keyType: "default",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    I: {
      keyType: "shift",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    o: {
      keyType: "default",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    O: {
      keyType: "shift",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    p: {
      keyType: "default",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    P: {
      keyType: "shift",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    "@": {
      keyType: "default",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "`": {
      keyType: "shift",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "[": {
      keyType: "default",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    "{": {
      keyType: "shift",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    Enter: {
      keyType: "default",
      position: [1, 13],
      hand: "right",
      finger: "fourth",
      size: "hexaEnter",
    },
    "caps lock": {
      keyType: "default",
      position: [2, 0],
      hand: "left",
      finger: "fourth",
      size: "L",
    },
    a: {
      keyType: "default",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    A: {
      keyType: "shift",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    s: {
      keyType: "default",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    S: {
      keyType: "shift",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    d: {
      keyType: "default",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    D: {
      keyType: "shift",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    f: {
      keyType: "default",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    F: {
      keyType: "shift",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    g: {
      keyType: "default",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    G: {
      keyType: "shift",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    h: {
      keyType: "default",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    H: {
      keyType: "shift",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    j: {
      keyType: "default",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    J: {
      keyType: "shift",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    k: {
      keyType: "default",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    K: {
      keyType: "shift",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    l: {
      keyType: "default",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    L: {
      keyType: "shift",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    ";": {
      keyType: "default",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    "+": {
      keyType: "shift",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    ":": {
      keyType: "default",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    "*": {
      keyType: "shift",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    "]": {
      keyType: "default",
      position: [2, 12],
      hand: "right",
      finger: "fourth",
    },
    "}": {
      keyType: "shift",
      position: [2, 12],
      hand: "right",
      finger: "fourth",
    },
    "l-Shift": {
      keyType: "default",
      position: [3, 0],
      hand: "left",
      finger: "fourth",
      size: "XXL",
    },
    z: {
      keyType: "default",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    Z: {
      keyType: "shift",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    x: {
      keyType: "default",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    X: {
      keyType: "shift",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    c: {
      keyType: "default",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    C: {
      keyType: "shift",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    v: {
      keyType: "default",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    V: {
      keyType: "shift",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    b: {
      keyType: "default",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    B: {
      keyType: "shift",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    n: {
      keyType: "default",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    N: {
      keyType: "shift",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    m: {
      keyType: "default",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    M: {
      keyType: "shift",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    ",": {
      keyType: "default",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    "<": {
      keyType: "shift",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    ".": {
      keyType: "default",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    ">": {
      keyType: "shift",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    "/": {
      keyType: "default",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "?": {
      keyType: "shift",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "\\": {
      keyType: "default",
      position: [3, 11],
      hand: "right",
      finger: "fourth",
    },
    _: {
      keyType: "shift",
      position: [3, 11],
      hand: "right",
      finger: "fourth",
    },
    "r-Shift": {
      keyType: "default",
      position: [3, 12],
      hand: "right",
      finger: "fourth",
      size: "XXL",
    },
    "l-Control": {
      keyType: "default",
      position: [4, 0],
      hand: "left",
      finger: "fourth",
      size: "L",
    },
    "l-win": {
      keyType: "default",
      position: [4, 1],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    "l-Alt": {
      keyType: "default",
      position: [4, 2],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    無変換: {
      keyType: "default",
      position: [4, 3],
      hand: "left",
      finger: "third",
      size: "M",
    },
    " ": {
      keyType: "default",
      position: [4, 4],
      hand: "left",
      finger: "thumb",
      size: "jis-space",
    },
    変換: {
      keyType: "default",
      position: [4, 5],
      hand: "right",
      finger: "first",
      size: "M",
    },
    カタひら: {
      keyType: "default",
      position: [4, 6],
      hand: "right",
      finger: "second",
      size: "M",
    },
    "r-Alt": {
      keyType: "default",
      position: [4, 7],
      hand: "right",
      finger: "third",
      size: "M",
    },
    "r-win": {
      keyType: "default",
      position: [4, 8],
      hand: "right",
      finger: "fourth",
      size: "M",
    },
    app: {
      keyType: "default",
      position: [4, 9],
      hand: "right",
      finger: "fourth",
      size: "M",
    },
    "r-Control": {
      keyType: "default",
      position: [4, 10],
      hand: "right",
      finger: "fourth",
    },
  },
  us: {
    "`": {
      keyType: "default",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
    },
    "~": {
      keyType: "shift",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
    },
    "1": {
      keyType: "default",
      position: [0, 1],
      hand: "left",
      finger: "fourth",
    },
    "!": {
      keyType: "shift",
      position: [0, 1],
      hand: "left",
      finger: "fourth",
    },
    "2": {
      keyType: "default",
      position: [0, 2],
      hand: "left",
      finger: "third",
    },
    "@": {
      keyType: "shift",
      position: [0, 2],
      hand: "left",
      finger: "third",
    },
    "3": {
      keyType: "default",
      position: [0, 3],
      hand: "left",
      finger: "second",
    },
    "#": {
      keyType: "shift",
      position: [0, 3],
      hand: "left",
      finger: "second",
    },
    "4": {
      keyType: "default",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    $: {
      keyType: "shift",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    "5": {
      keyType: "default",
      position: [0, 5],
      hand: "left",
      finger: "first",
    },
    "%": {
      keyType: "shift",
      position: [0, 5],
      hand: "left",
      finger: "first",
    },
    "6": {
      keyType: "default",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "^": {
      keyType: "shift",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "7": {
      keyType: "default",
      position: [0, 7],
      hand: "right",
      finger: "first",
    },
    "&": {
      keyType: "shift",
      position: [0, 7],
      hand: "right",
      finger: "first",
    },
    "8": {
      keyType: "default",
      position: [0, 8],
      hand: "right",
      finger: "second",
    },
    "*": {
      keyType: "shift",
      position: [0, 8],
      hand: "right",
      finger: "second",
    },
    "9": {
      keyType: "default",
      position: [0, 9],
      hand: "right",
      finger: "third",
    },
    "(": {
      keyType: "shift",
      position: [0, 9],
      hand: "right",
      finger: "third",
    },
    "0": {
      keyType: "default",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    ")": {
      keyType: "shift",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    "-": {
      keyType: "default",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    _: {
      keyType: "shift",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    "=": {
      keyType: "default",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    "+": {
      keyType: "shift",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    Backspace: {
      keyType: "default",
      position: [0, 13],
      hand: "right",
      finger: "fourth",
      size: "L",
    },
    Tab: {
      keyType: "default",
      position: [1, 0],
      hand: "left",
      finger: "fourth",
      size: "L",
    },
    q: {
      keyType: "default",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    Q: {
      keyType: "shift",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    w: {
      keyType: "default",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    W: {
      keyType: "shift",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    e: {
      keyType: "default",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    E: {
      keyType: "shift",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    r: {
      keyType: "default",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    R: {
      keyType: "shift",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    t: {
      keyType: "default",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    T: {
      keyType: "shift",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    y: {
      keyType: "default",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    Y: {
      keyType: "shift",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    u: {
      keyType: "default",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    U: {
      keyType: "shift",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    i: {
      keyType: "default",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    I: {
      keyType: "shift",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    o: {
      keyType: "default",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    O: {
      keyType: "shift",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    p: {
      keyType: "default",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    P: {
      keyType: "shift",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    "[": {
      keyType: "default",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "{": {
      keyType: "shift",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "]": {
      keyType: "default",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    "}": {
      keyType: "shift",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    "\\": {
      keyType: "default",
      position: [1, 13],
      hand: "right",
      finger: "fourth",
    },
    "|": {
      keyType: "shift",
      position: [1, 13],
      hand: "right",
      finger: "fourth",
    },
    "caps lock": {
      keyType: "default",
      position: [2, 0],
      hand: "left",
      finger: "fourth",
      size: "XL",
    },
    a: {
      keyType: "default",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    A: {
      keyType: "shift",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    s: {
      keyType: "default",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    S: {
      keyType: "shift",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    d: {
      keyType: "default",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    D: {
      keyType: "shift",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    f: {
      keyType: "default",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    F: {
      keyType: "shift",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    g: {
      keyType: "default",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    G: {
      keyType: "shift",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    h: {
      keyType: "default",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    H: {
      keyType: "shift",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    j: {
      keyType: "default",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    J: {
      keyType: "shift",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    k: {
      keyType: "default",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    K: {
      keyType: "shift",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    l: {
      keyType: "default",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    L: {
      keyType: "shift",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    ";": {
      keyType: "default",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    ":": {
      keyType: "shift",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    "'": {
      keyType: "default",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    '"': {
      keyType: "shift",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    Enter: {
      keyType: "default",
      position: [2, 12],
      hand: "right",
      finger: "fourth",
      size: "XL",
    },
    "l-Shift": {
      keyType: "default",
      position: [3, 0],
      hand: "left",
      finger: "fourth",
      size: "XXXL",
    },
    z: {
      keyType: "default",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    Z: {
      keyType: "shift",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    x: {
      keyType: "default",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    X: {
      keyType: "shift",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    c: {
      keyType: "default",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    C: {
      keyType: "shift",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    v: {
      keyType: "default",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    V: {
      keyType: "shift",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    b: {
      keyType: "default",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    B: {
      keyType: "shift",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    n: {
      keyType: "default",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    N: {
      keyType: "shift",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    m: {
      keyType: "default",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    M: {
      keyType: "shift",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    ",": {
      keyType: "default",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    "<": {
      keyType: "shift",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    ".": {
      keyType: "default",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    ">": {
      keyType: "shift",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    "/": {
      keyType: "default",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "?": {
      keyType: "shift",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "r-Shift": {
      keyType: "default",
      position: [3, 11],
      hand: "right",
      finger: "fourth",
      size: "XXXL",
    },
    "l-Control": {
      keyType: "default",
      position: [4, 0],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    "l-win": {
      keyType: "default",
      position: [4, 1],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    "l-Alt": {
      keyType: "default",
      position: [4, 2],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    " ": {
      keyType: "default",
      position: [4, 3],
      hand: "left",
      finger: "thumb",
      size: "us-space",
    },
    "r-Alt": {
      keyType: "default",
      position: [4, 4],
      hand: "right",
      finger: "third",
      size: "M",
    },
    "r-win": {
      keyType: "default",
      position: [4, 5],
      hand: "right",
      finger: "fourth",
      size: "M",
    },
    app: {
      keyType: "default",
      position: [4, 6],
      hand: "right",
      finger: "fourth",
      size: "M",
    },
    "r-Control": {
      keyType: "default",
      position: [4, 7],
      hand: "right",
      finger: "fourth",
      size: "M",
    },
  },
  "mac-jis": {
    "1": {
      keyType: "default",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
      size: "L",
    },
    "!": {
      keyType: "shift",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
    },
    "2": {
      keyType: "default",
      position: [0, 1],
      hand: "left",
      finger: "third",
    },
    '"': {
      keyType: "shift",
      position: [0, 1],
      hand: "left",
      finger: "third",
    },
    "3": {
      keyType: "default",
      position: [0, 2],
      hand: "left",
      finger: "second",
    },
    "#": {
      keyType: "shift",
      position: [0, 2],
      hand: "left",
      finger: "second",
    },
    "4": {
      keyType: "default",
      position: [0, 3],
      hand: "left",
      finger: "first",
    },
    $: {
      keyType: "shift",
      position: [0, 3],
      hand: "left",
      finger: "first",
    },
    "5": {
      keyType: "default",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    "%": {
      keyType: "shift",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    "6": {
      keyType: "default",
      position: [0, 5],
      hand: "right",
      finger: "first",
    },
    "&": {
      keyType: "shift",
      position: [0, 5],
      hand: "right",
      finger: "first",
    },
    "7": {
      keyType: "default",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "'": {
      keyType: "shift",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "8": {
      keyType: "default",
      position: [0, 7],
      hand: "right",
      finger: "second",
    },
    "(": {
      keyType: "shift",
      position: [0, 7],
      hand: "right",
      finger: "second",
    },
    "9": {
      keyType: "default",
      position: [0, 8],
      hand: "right",
      finger: "third",
    },
    ")": {
      keyType: "shift",
      position: [0, 8],
      hand: "right",
      finger: "third",
    },
    "0": {
      keyType: "default",
      position: [0, 9],
      hand: "right",
      finger: "fourth",
    },
    "-": {
      keyType: "default",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    "=": {
      keyType: "shift",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    "^": {
      keyType: "default",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    "~": {
      keyType: "shift",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    "¥": {
      keyType: "default",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    "|": {
      keyType: "shift",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    "\\": {
      keyType: "option",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    Backspace: {
      keyType: "default",
      position: [0, 13],
      hand: "right",
      finger: "fourth",
    },
    Tab: {
      keyType: "default",
      position: [1, 0],
      hand: "left",
      finger: "fourth",
    },
    q: {
      keyType: "default",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    Q: {
      keyType: "shift",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    w: {
      keyType: "default",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    W: {
      keyType: "shift",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    e: {
      keyType: "default",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    E: {
      keyType: "shift",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    r: {
      keyType: "default",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    R: {
      keyType: "shift",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    t: {
      keyType: "default",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    T: {
      keyType: "shift",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    y: {
      keyType: "default",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    Y: {
      keyType: "shift",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    u: {
      keyType: "default",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    U: {
      keyType: "shift",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    i: {
      keyType: "default",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    I: {
      keyType: "shift",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    o: {
      keyType: "default",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    O: {
      keyType: "shift",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    p: {
      keyType: "default",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    P: {
      keyType: "shift",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    "@": {
      keyType: "default",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "`": {
      keyType: "shift",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "[": {
      keyType: "default",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    "{": {
      keyType: "shift",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    Enter: {
      keyType: "default",
      position: [1, 13],
      hand: "right",
      finger: "fourth",
      size: "hexaEnter",
    },
    Control: {
      keyType: "default",
      position: [2, 0],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    a: {
      keyType: "default",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    A: {
      keyType: "shift",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    s: {
      keyType: "default",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    S: {
      keyType: "shift",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    d: {
      keyType: "default",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    D: {
      keyType: "shift",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    f: {
      keyType: "default",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    F: {
      keyType: "shift",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    g: {
      keyType: "default",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    G: {
      keyType: "shift",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    h: {
      keyType: "default",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    H: {
      keyType: "shift",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    j: {
      keyType: "default",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    J: {
      keyType: "shift",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    k: {
      keyType: "default",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    K: {
      keyType: "shift",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    l: {
      keyType: "default",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    L: {
      keyType: "shift",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    ";": {
      keyType: "default",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    "+": {
      keyType: "shift",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    ":": {
      keyType: "default",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    "*": {
      keyType: "shift",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    "]": {
      keyType: "default",
      position: [2, 12],
      hand: "right",
      finger: "fourth",
    },
    "}": {
      keyType: "shift",
      position: [2, 12],
      hand: "right",
      finger: "fourth",
    },
    "l-Shift": {
      keyType: "default",
      position: [3, 0],
      hand: "left",
      finger: "fourth",
      size: "XL",
    },
    z: {
      keyType: "default",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    Z: {
      keyType: "shift",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    x: {
      keyType: "default",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    X: {
      keyType: "shift",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    c: {
      keyType: "default",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    C: {
      keyType: "shift",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    v: {
      keyType: "default",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    V: {
      keyType: "shift",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    b: {
      keyType: "default",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    B: {
      keyType: "shift",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    n: {
      keyType: "default",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    N: {
      keyType: "shift",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    m: {
      keyType: "default",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    M: {
      keyType: "shift",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    ",": {
      keyType: "default",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    "<": {
      keyType: "shift",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    ".": {
      keyType: "default",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    ">": {
      keyType: "shift",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    "/": {
      keyType: "default",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "?": {
      keyType: "shift",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    _: {
      keyType: "default",
      position: [3, 11],
      hand: "right",
      finger: "fourth",
    },
    "r-Shift": {
      keyType: "default",
      position: [3, 12],
      hand: "right",
      finger: "fourth",
      size: "XL",
    },
    "caps lock": {
      keyType: "default",
      position: [4, 0],
      hand: "left",
      finger: "fourth",
    },
    option: {
      keyType: "default",
      position: [4, 1],
      hand: "left",
      finger: "fourth",
    },
    "l-Meta": {
      keyType: "default",
      position: [4, 2],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    英数: {
      keyType: "default",
      position: [4, 3],
      hand: "left",
      finger: "third",
      size: "M",
    },
    " ": {
      keyType: "default",
      position: [4, 4],
      hand: "left",
      finger: "thumb",
      size: "mac-jis-space",
    },
    かな: {
      keyType: "default",
      position: [4, 5],
      hand: "right",
      finger: "first",
      size: "M",
    },
    "r-Meta": {
      keyType: "default",
      position: [4, 6],
      hand: "right",
      finger: "second",
      size: "M",
    },
    fn: {
      keyType: "default",
      position: [4, 7],
      hand: "right",
      finger: "third",
    },
  },
  "mac-us": {
    "`": {
      keyType: "default",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
    },
    "~": {
      keyType: "shift",
      position: [0, 0],
      hand: "left",
      finger: "fourth",
    },
    "1": {
      keyType: "default",
      position: [0, 1],
      hand: "left",
      finger: "fourth",
    },
    "!": {
      keyType: "shift",
      position: [0, 1],
      hand: "left",
      finger: "fourth",
    },
    "2": {
      keyType: "default",
      position: [0, 2],
      hand: "left",
      finger: "third",
    },
    "@": {
      keyType: "shift",
      position: [0, 2],
      hand: "left",
      finger: "third",
    },
    "3": {
      keyType: "default",
      position: [0, 3],
      hand: "left",
      finger: "second",
    },
    "#": {
      keyType: "shift",
      position: [0, 3],
      hand: "left",
      finger: "second",
    },
    "4": {
      keyType: "default",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    $: {
      keyType: "shift",
      position: [0, 4],
      hand: "left",
      finger: "first",
    },
    "5": {
      keyType: "default",
      position: [0, 5],
      hand: "left",
      finger: "first",
    },
    "%": {
      keyType: "shift",
      position: [0, 5],
      hand: "left",
      finger: "first",
    },
    "6": {
      keyType: "default",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "^": {
      keyType: "shift",
      position: [0, 6],
      hand: "right",
      finger: "first",
    },
    "7": {
      keyType: "default",
      position: [0, 7],
      hand: "right",
      finger: "first",
    },
    "&": {
      keyType: "shift",
      position: [0, 7],
      hand: "right",
      finger: "first",
    },
    "8": {
      keyType: "default",
      position: [0, 8],
      hand: "right",
      finger: "second",
    },
    "*": {
      keyType: "shift",
      position: [0, 8],
      hand: "right",
      finger: "second",
    },
    "9": {
      keyType: "default",
      position: [0, 9],
      hand: "right",
      finger: "third",
    },
    "(": {
      keyType: "shift",
      position: [0, 9],
      hand: "right",
      finger: "third",
    },
    "0": {
      keyType: "default",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    ")": {
      keyType: "shift",
      position: [0, 10],
      hand: "right",
      finger: "fourth",
    },
    "-": {
      keyType: "default",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    _: {
      keyType: "shift",
      position: [0, 11],
      hand: "right",
      finger: "fourth",
    },
    "=": {
      keyType: "default",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    "+": {
      keyType: "shift",
      position: [0, 12],
      hand: "right",
      finger: "fourth",
    },
    Backspace: {
      keyType: "default",
      position: [0, 13],
      hand: "right",
      finger: "fourth",
      size: "L",
    },
    Tab: {
      keyType: "default",
      position: [1, 0],
      hand: "left",
      finger: "fourth",
      size: "L",
    },
    q: {
      keyType: "default",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    Q: {
      keyType: "shift",
      position: [1, 1],
      hand: "left",
      finger: "fourth",
    },
    w: {
      keyType: "default",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    W: {
      keyType: "shift",
      position: [1, 2],
      hand: "left",
      finger: "third",
    },
    e: {
      keyType: "default",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    E: {
      keyType: "shift",
      position: [1, 3],
      hand: "left",
      finger: "second",
    },
    r: {
      keyType: "default",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    R: {
      keyType: "shift",
      position: [1, 4],
      hand: "left",
      finger: "first",
    },
    t: {
      keyType: "default",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    T: {
      keyType: "shift",
      position: [1, 5],
      hand: "left",
      finger: "first",
    },
    y: {
      keyType: "default",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    Y: {
      keyType: "shift",
      position: [1, 6],
      hand: "right",
      finger: "first",
    },
    u: {
      keyType: "default",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    U: {
      keyType: "shift",
      position: [1, 7],
      hand: "right",
      finger: "first",
    },
    i: {
      keyType: "default",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    I: {
      keyType: "shift",
      position: [1, 8],
      hand: "right",
      finger: "second",
    },
    o: {
      keyType: "default",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    O: {
      keyType: "shift",
      position: [1, 9],
      hand: "right",
      finger: "third",
    },
    p: {
      keyType: "default",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    P: {
      keyType: "shift",
      position: [1, 10],
      hand: "right",
      finger: "fourth",
    },
    "[": {
      keyType: "default",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "{": {
      keyType: "shift",
      position: [1, 11],
      hand: "right",
      finger: "fourth",
    },
    "]": {
      keyType: "default",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    "}": {
      keyType: "shift",
      position: [1, 12],
      hand: "right",
      finger: "fourth",
    },
    "\\": {
      keyType: "default",
      position: [1, 13],
      hand: "right",
      finger: "fourth",
    },
    "|": {
      keyType: "shift",
      position: [1, 13],
      hand: "right",
      finger: "fourth",
    },
    "caps lock": {
      keyType: "default",
      position: [2, 0],
      hand: "left",
      finger: "fourth",
      size: "XL",
    },
    a: {
      keyType: "default",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    A: {
      keyType: "shift",
      position: [2, 1],
      hand: "left",
      finger: "fourth",
    },
    s: {
      keyType: "default",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    S: {
      keyType: "shift",
      position: [2, 2],
      hand: "left",
      finger: "third",
    },
    d: {
      keyType: "default",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    D: {
      keyType: "shift",
      position: [2, 3],
      hand: "left",
      finger: "second",
    },
    f: {
      keyType: "default",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    F: {
      keyType: "shift",
      position: [2, 4],
      hand: "left",
      finger: "first",
    },
    g: {
      keyType: "default",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    G: {
      keyType: "shift",
      position: [2, 5],
      hand: "left",
      finger: "first",
    },
    h: {
      keyType: "default",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    H: {
      keyType: "shift",
      position: [2, 6],
      hand: "right",
      finger: "first",
    },
    j: {
      keyType: "default",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    J: {
      keyType: "shift",
      position: [2, 7],
      hand: "right",
      finger: "first",
    },
    k: {
      keyType: "default",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    K: {
      keyType: "shift",
      position: [2, 8],
      hand: "right",
      finger: "second",
    },
    l: {
      keyType: "default",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    L: {
      keyType: "shift",
      position: [2, 9],
      hand: "right",
      finger: "third",
    },
    ";": {
      keyType: "default",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    ":": {
      keyType: "shift",
      position: [2, 10],
      hand: "right",
      finger: "fourth",
    },
    "'": {
      keyType: "default",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    '"': {
      keyType: "shift",
      position: [2, 11],
      hand: "right",
      finger: "fourth",
    },
    Enter: {
      keyType: "default",
      position: [2, 12],
      hand: "right",
      finger: "fourth",
      size: "XL",
    },
    "l-Shift": {
      keyType: "default",
      position: [3, 0],
      hand: "left",
      finger: "fourth",
      size: "XXXL",
    },
    z: {
      keyType: "default",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    Z: {
      keyType: "shift",
      position: [3, 1],
      hand: "left",
      finger: "fourth",
    },
    x: {
      keyType: "default",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    X: {
      keyType: "shift",
      position: [3, 2],
      hand: "left",
      finger: "third",
    },
    c: {
      keyType: "default",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    C: {
      keyType: "shift",
      position: [3, 3],
      hand: "left",
      finger: "second",
    },
    v: {
      keyType: "default",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    V: {
      keyType: "shift",
      position: [3, 4],
      hand: "left",
      finger: "first",
    },
    b: {
      keyType: "default",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    B: {
      keyType: "shift",
      position: [3, 5],
      hand: "left",
      finger: "first",
    },
    n: {
      keyType: "default",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    N: {
      keyType: "shift",
      position: [3, 6],
      hand: "right",
      finger: "first",
    },
    m: {
      keyType: "default",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    M: {
      keyType: "shift",
      position: [3, 7],
      hand: "right",
      finger: "first",
    },
    ",": {
      keyType: "default",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    "<": {
      keyType: "shift",
      position: [3, 8],
      hand: "right",
      finger: "second",
    },
    ".": {
      keyType: "default",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    ">": {
      keyType: "shift",
      position: [3, 9],
      hand: "right",
      finger: "third",
    },
    "/": {
      keyType: "default",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "?": {
      keyType: "shift",
      position: [3, 10],
      hand: "right",
      finger: "fourth",
    },
    "r-Shift": {
      keyType: "default",
      position: [3, 11],
      hand: "right",
      finger: "fourth",
      size: "XXXL",
    },
    Control: {
      keyType: "default",
      position: [4, 0],
      hand: "left",
      finger: "fourth",
      size: "XL",
    },
    option: {
      keyType: "default",
      position: [4, 1],
      hand: "left",
      finger: "fourth",
      size: "M",
    },
    "l-Meta": {
      keyType: "default",
      position: [4, 2],
      hand: "left",
      finger: "fourth",
      size: "XL",
    },
    " ": {
      keyType: "default",
      position: [4, 3],
      hand: "left",
      finger: "thumb",
      size: "mac-us-space",
    },
    "r-Meta": {
      keyType: "default",
      position: [4, 4],
      hand: "right",
      finger: "third",
      size: "XL",
    },
  },
};
